export enum SignInMethodType {
  PHONE = 'phone',
  EMAIL = 'email'
}

export interface SignInMethodOption {
  type: SignInMethodType;
  label: string;
  value: string;
}

export interface SignInVerification {
  oyanaid: string;
  email: string;
  whatsapp: string;
}
